/**
 * The Quote page header's "Updated By" line.
 *
 * The username is resolved server-side (DealSerializer.updated_by_username),
 * which falls back to the quote's creator when nobody has edited it yet — so a
 * quote always names someone. The timestamp stays client-side so it renders in
 * the viewer's own timezone, as it always has.
 *
 * Returns null when there is nothing sensible to show, so the caller can skip
 * the row entirely rather than print "Updated NaN/NaN Invalid Date".
 */
export const buildUpdatedLabel = (deal) => {
    const updatedAt = deal?.updated_at
    if (!updatedAt) return null

    const date = new Date(updatedAt)
    if (Number.isNaN(date.getTime())) return null

    const stamp = `${date.getMonth() + 1}/${date.getDate()} `
        + date.toLocaleTimeString(undefined, {timeStyle: 'short'})

    // Absent on responses from an API that predates the field — fall back to the
    // original "Updated <stamp>" so an old backend still renders correctly.
    const username = (deal?.updated_by_username || '').trim()

    return username ? `Updated by ${username} ${stamp}` : `Updated ${stamp}`
}
